import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import { isDefined } from "@/utils/validations";
import { Subscription } from "@/types/entities";
import storage from "@/utils/storage";
import api from "@/config/api";

const useQuerySubscription = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");

    const enabled = authenticated && isDefined(oid);

    const getSubscription = async () => {
        try {
            const data = await api.get<Subscription>(`/organizations/${oid}/subscription`);
            return data;
        } catch (e) {
            log.error(e, "getSubscription");
        }
    };

    return useQuery({ queryKey: ["subscription", oid], queryFn: getSubscription, enabled });
};

export default useQuerySubscription;
